import React from 'react';
import '../styles/theme.css';
import '../styles/Landing.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LandingHero from '../components/LandingHero';
import LandingStatement from '../components/LandingStatement';
/* IMPORTS */

function LandingPage() {
  return (
    <div className="la-root">
      <div id="navbar" className="la-slot-navbar">
        <Navbar activePage={"Landing"} />
      </div>
      <div id="landinghero" className="la-slot-landinghero">
        <LandingHero />
      </div>
      <div id="landingstatement" className="la-slot-landingstatement">
        <LandingStatement />
      </div>
      <div id="footer" className="la-slot-footer">
        <Footer />
      </div>
    </div>
  );
}

export default LandingPage;
